export default __webpack_public_path__ + "static/media/cloud.a597ed60.svg";